/**
 * External store for wishlist state that persists across component remounts.
 */
import { create } from 'zustand'
import type { WishlistItem } from '@velasca/types'

interface WishlistStore {
  items: WishlistItem[]
  setItems: (items: WishlistItem[]) => void
}

export const useWishlistStore = create<WishlistStore>()((set) => ({
  items: [],
  setItems: (items) => {
    set({ items })
  },
}))
